import C from "@/components/forms/Radio.module.css";
import R from "@/components/forms/WFakeRadio.module.css";

import { mcn, type BaseProps } from "@/utils/baseProps.ts";
import type { ReactNode } from "react";
import { Button } from "react-aria-components";

export function WFakeRadio({
    children,
    isSelected,
    isDisabled,
    onClick,
    ...props
}: {
    children?: ReactNode;
    isSelected: boolean;
    isDisabled?: boolean;
    onClick?: (value: boolean) => void;
} & BaseProps) {
    function onChange() {
        onClick?.(!isSelected);
    }

    return (
        <Button
            isDisabled={isDisabled}
            data-selected={isSelected ? true : undefined}
            data-disabled={isDisabled ? true : undefined}
            onPress={onChange}
            {...mcn(`${C.Radio} ${R.Radio}`, props)}
        >
            {children}
        </Button>
    );
}
